/** Bind a default recipe and named parameter variants without duplicating generator dispatch. */
import type { PieceArt, PieceDefinition, PieceRecipe, ResolvedPalette } from './contract';

export function definePiece<R extends PieceRecipe<string, unknown>>(
  recipe: R,
  build: (recipe: R, roles: ResolvedPalette, scope: string) => PieceArt,
  variants: Readonly<Record<string, R['params']>> = {},
): PieceDefinition {
  return {
    recipe,
    build: (roles, scope) => build(recipe, roles, scope),
    variants: Object.fromEntries(Object.entries(variants).map(([name, params]) => [name,
      (roles: ResolvedPalette, scope: string) => build({ ...recipe, params }, roles, scope),
    ])),
  };
}
